/**
 * @description vue状态管理
 */

import store from "vuex"
import Vue from "vue"

Vue.use(store)

export default new store.Store({
    state: {
        // 登录状态
        loginState: false,
        // 用户信息
        userInfo: {

        },
        // 设备运维电梯数据
        Elevator: [],
        batteryDoorId: '',
        changeEvent: {},
        threeLoad: false,//，模型加载
        isDisabled: true,//是否可点击
        threeEvent: {
            intoWaterCon: false,//进入水能耗
            intoEleCon: false,//进入电能耗
            intoElevator: false,//进入电梯
            intoPDJ: false,//进入配电间
            intoWaterPump: false,//进入水泵
            intoFireUnder: false,//进入消防地下
            intoFire: false,//进入消防
            intoParking: false,//进入停车场
            intoEnviron: false,//进入环境监测
            intoAirCon: false,//进入空调
            intoGateway: false,//进入网关
            intoIllumina: false,//进入灯光
            intoJk: false,//进入监控
            intoWarnCenter: false,//进入告警中心
        },
    },
    mutations: {
        // // 登录
        // loginIn(state) {
        //     state.loginState = true;
        // },
        // // 登出
        // loginOut(state) {
        //     state.loginState = false;
        // },
        // setUserInfo(state, userInfo) {
        //     state.userInfo = userInfo || {}
        // },

        // setBatteyId(state, id) {
        //     state.batteryDoorId = id;
        // }
    },
    actions: {
    }
})
